export interface OrchestrationAssistantState {
    session_id: string | null;
    messages: any[];
    sessions: any[];
    loading: boolean;
    error: any | null;
}

export const initialOrchestrationAssistantState: OrchestrationAssistantState = {
    session_id: null,
    messages: [],
    sessions: [],
    loading: false,
    error: null,
};
